export default {
  id: null,
  email: null,
  fullname: null,
  phone_number: null,
  work_in: null,
  role: null,
  status: null,
  signup: null,
  activated: null,
  last_login: null,
  credits: null,
  keywords_count: 0,
  projects_count: 0,
  reports_count: 0,
  links_count: 0,
  permissions: null,
  overridden_permissions: null,
  projects: null,
  first_day_of_week: 0,
  currency: 1,
  active_plan: '',
  ip_data: null,
  package_id: 0,
  package_expired_at: '',
  keywords_limit: 0,
  projects_limit: 0,
  links_limit: 0,
  reports_limit: 0,
  history_starts_at: '',
  made_reports: 0,
  // is_ten_club_member: false,
  ten_club_reports: [],
  subscription_renew: false,
  statuses: {
    NotVerified: 0,
    EmailOnlyVerified: 1,
    PhoneOnlyVerified: 2,
    EmailAndPhoneVerified: 3,
    AlternativeVerified: 4,
    Deleted: 100,
    Blocked: 101
  },
  statusesSeletc: [
    { text: 'Not verified', value: 0, shortText: 'NF' },
    { text: 'Email verified', value: 1, shortText: 'EV' },
    { text: 'Phone verified', value: 2, shortText: 'PV' },
    { text: 'Verified', value: 3, shortText: 'V' },
    { text: 'Alternative', value: 4, shortText: 'Alt' },
    { text: 'Deleted', value: 100, shortText: 'D' },
    { text: 'Blocked', value: 101, shortText: 'B' }
  ],
  is_trial_available: null,
  is_trial: null,
  package_type: null
}



// WEBPACK FOOTER //
// ./src/store/user/state.js